import { blobToBase64 } from '@avalenti89/typescript-utils';

type IBaseResource = {
	mime_type: string;
	size: number;
	name: string;
	resource_id?: string;
};

export type IFileResource = IBaseResource & {
	data: string;
};
export type IMetaResource = Partial<IBaseResource> & {
	resource_id: string;
	data?: string;
};

export type IResources = IFileResource | IMetaResource;

export const Resource = <T extends IResources | File>(
	data: T
): Promise<T extends IResources ? T : IFileResource> => {
	if (data instanceof File) {
		const mime_type: IFileResource['mime_type'] = data.type;
		const size: IFileResource['size'] = data.size;
		const name: IFileResource['name'] = data.name;
		return blobToBase64(data).then<IFileResource>((base) => {
			if (Array.isArray(base) || base instanceof ArrayBuffer || !base) {
				throw new Error('Invalid base64');
			} else {
				return {
					mime_type,
					name,
					size,
					data: base,
				};
			}
		}) as any;
	} else if (isMetaResource(data)) {
		return Promise.resolve<any>(data);
	} else {
		return Promise.reject(new Error('Invalid data'));
	}
};

export const isFileResource = (
	resource: IResources
): resource is IFileResource => !!resource.data;
export const isMetaResource = (
	resource: IResources
): resource is IMetaResource => !resource.data;
